import { useEffect, useState } from 'react';
import { Marker, Tooltip } from 'react-leaflet';
import L from 'leaflet';
import { localApi } from '../utils/localApi';
import { TrainFront } from 'lucide-react';
import { renderToStaticMarkup } from 'react-dom/server';

interface TrainPosition {
    session_id: string;
    latitude: number;
    longitude: number;
    mission_name: string;
    updated_at: string;
}

interface TrainPositionsLayerProps {
    currentUserId?: string;
}

export default function TrainPositionsLayer({ currentUserId }: TrainPositionsLayerProps) {
    const [positions, setPositions] = useState<TrainPosition[]>([]);

    useEffect(() => {
        // 1. Chargement initial et rafraîchissement
        const fetchPositions = async () => {
            try {
                const data = await localApi.getGpsPositions();
                setPositions(data);
            } catch (err) {
                console.error("Erreur de récupération des positions GPS locales :", err);
            }
        };

        fetchPositions();

        // 2. Polling régulier toutes les 5 secondes
        const interval = setInterval(fetchPositions, 5000);

        return () => {
            clearInterval(interval);
        };
    }, []);

    // Icône personnalisée pour les trains (Point circulaire avec icône Train)
    const createTrainIcon = () => {
        const html = renderToStaticMarkup(
            <div className="relative flex items-center justify-center">
                {/* Halo d'animation pour le mouvement (optionnel) */}
                <div className="absolute inset-0 bg-blue-500/20 rounded-full animate-ping scale-150"></div>
                
                {/* Cercle principal */}
                <div className="w-10 h-10 bg-slate-900 border-2 border-blue-400 rounded-full flex items-center justify-center shadow-[0_0_15px_rgba(59,130,246,0.5)]">
                    <TrainFront className="text-blue-400 w-6 h-6" />
                </div>
            </div>
        );

        return L.divIcon({
            className: 'train-marker',
            html: html,
            iconSize: [40, 40],
            iconAnchor: [20, 20]
        });
    };

    return (
        <>
            {positions
                .filter(p => 
                    p.session_id !== currentUserId && 
                    p.latitude !== null && p.latitude !== undefined && !isNaN(p.latitude) &&
                    p.longitude !== null && p.longitude !== undefined && !isNaN(p.longitude)
                )
                .map((pos) => (
                <Marker
                    key={pos.session_id}
                    position={[pos.latitude, pos.longitude]}
                    icon={createTrainIcon()}
                >
                    <Tooltip permanent direction="top" offset={[0, -20]} className="train-tooltip">
                        <div className="bg-slate-900/90 border border-blue-500/30 px-2 py-1 rounded-md shadow-xl">
                            <p className="text-[10px] font-black text-white uppercase tracking-tighter">
                                {pos.mission_name}
                            </p>
                            <p className="text-[7px] text-blue-400 font-bold uppercase tracking-widest mt-0.5">
                                Mis à jour: {new Date(pos.updated_at).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                            </p>
                        </div>
                    </Tooltip>
                </Marker>
            ))}
        </>
    );
}
